import { render, staticRenderFns } from "./ForceTerminateDialog.vue?vue&type=template&id=23e97878&lang=pug&"
import script from "./ForceTerminateDialog.vue?vue&type=script&lang=ts&"
export * from "./ForceTerminateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ForceTerminateDialog.vue?vue&type=style&index=0&id=23e97878&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports